import { MULTISIG_PARSER_ENDPOINT } from '~/config.js';
import axios from 'axios';

/* eslint camelcase: "off", func-names: "off" */

// Disable headers if api key is not set. Otherwise
// axios will make a pre-flight request:

const http = axios.create({
    baseURL: MULTISIG_PARSER_ENDPOINT,
});

export const getMultisigInfo = async function (address) {
    const { data } = await http.get(`contract/${address}`);

    return data;
};

export const getMultisigOrderInfo = async function (address) {
    const { data } = await http.get(`order/${address}`);

    return data;
};
